import pageLoaderTemplate from './pageLoader.html';

class PageLoaderService {
  constructor($uibModal){
    this.$uibModal = $uibModal;
  }

  show(){
    this.pageLoader = this.$uibModal.open({
      template: pageLoaderTemplate,
      keyboard: false,
      backdrop: 'static',
      windowClass: 'animation-center'
    });
  }

  hide(){
    this.pageLoader.close();
  }
}

PageLoaderService.$inject = ['$uibModal'];

export default PageLoaderService;




// WEBPACK FOOTER //
// ./app/common/pageLoader/pageLoader.service.js